module.exports = "/_next/static/images/CompanyServices-2x-56e83075ae2a1bacd33961cf49f1805c.jpg.webp";